import { render } from "./QuotationList.vue?vue&type=template&id=23af011f&scoped=true&ts=true"
import script from "./QuotationList.vue?vue&type=script&lang=ts"
export * from "./QuotationList.vue?vue&type=script&lang=ts"

import "./QuotationList.vue?vue&type=style&index=0&id=23af011f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23af011f"]])

export default __exports__